

exports.__esModule = true;
exports.$xoAddNationalIdPageComponent = undefined;

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _user = require('xo-models/src/user');

var _checkout = require('xo-models/src/checkout');

var _directive = require('xo-form-components/src/national-id-input/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-page-components/src/value-props/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddNationalIdPageComponent = exports.$xoAddNationalIdPageComponent = _squid.$Component.extend('$xoAddNationalIdPageComponent', {
    tag: 'xo-add-national-id-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.locale = _squid.$locale;
        $scope.user = {
            country: _squid.$locale.country,
            countryOfResidence: _squid.$locale.country
        };
        $scope.validate = function () {
            $scope.validated = true;
            return true;
        };
        $scope.onContinue = function () {
            $scope.nationalIdModel = _directive.$NationalIdModel.instance(_angular.$rootScope.token);
            $scope.checkoutSession = _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token);
            $scope.addKYC = new _user.$AddKYCModel({
                token: _angular.$rootScope.token
            });
            $scope.KYCData = {
                nationalIdModel: $scope.nationalIdModel,
                user: $scope.user
            };
            $scope.addKYC.save({
                data: $scope.KYCData,
                success: function success() {
                    return _uiRouter.$state.go('checkout.review');
                },
                contingencies: {
                    DEFAULT: function DEFAULT(err, message) {
                        _logger.$logger.info('add_KYC_contingency', {
                            name: err,
                            message: message
                        });
                    }
                }
            });
        };
    }]
});

angular.value("$xoAddNationalIdPageComponent", $xoAddNationalIdPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_logger.$logger;

_user.$AddKYCModel;

_checkout.$CheckoutSessionModel;

_directive.$NationalIdModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-national-id/directive.js
// module id = ./pages/xo-add-national-id/directive.js
// module chunks = 0